import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { useQuery } from '@tanstack/react-query';
import { fetchSupplierPromise } from '@bridebook/web/app-shared/lib/supplier/utils/fetch-supplier-promise';
import { toMillis } from '@bridebook/web/lib/utils';

const SUPPLIER_BY_PUBLIC_ID_QUERY_CACHE_TIME = toMillis(15, 'min');

export const QUERY_KEY = 'supplier';
export const getQueryFn = (publicId: string, locale?: string) => async () =>
  await fetchSupplierPromise(publicId, { locale });
export const QUERY_OPTIONS = {
  cacheTime: SUPPLIER_BY_PUBLIC_ID_QUERY_CACHE_TIME,
  staleTime: SUPPLIER_BY_PUBLIC_ID_QUERY_CACHE_TIME,
};

/**
 * Returns a supplier details based on publicId
 */
export const useFetchSupplierByPublicId = (
  publicId?: string,
  locale?: string,
  onSuccess?: (supplier: ISupplier) => void,
) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, publicId],
    getQueryFn(publicId as string, locale),
    {
      enabled: !!publicId,
      ...QUERY_OPTIONS,
      onSuccess,
    },
  );

  return {
    supplierSuggestions: data,
    isLoading,
  };
};
